import watchListApi from '@/api/watchList';
import { loadEntity, enhanceOrAdd } from '@/helpers/utility';

const state = {
    byId: {},
};

const actions = {
    async getWatchLists(store) {
        let response = await watchListApi.list();
        loadEntity({ watchLists: response.data });
    },
    async getWatchList(store, { id }) {
        let response = await watchListApi.get(id);
        loadEntity({ watchList: response.data });
    },
    async createWatchList(store, { watchList }) {
        let response = await watchListApi.create(watchList);
        loadEntity({ watchList: response.data });
        return response.data;
    },
    async updateWatchList(store, { watchList }) {
        let response = await watchListApi.update(watchList);
        loadEntity({ watchList: response.data });
    },
    async deleteWatchList({ commit }, { watchList }) {
        let response = await watchListApi.delete(watchList);
        commit('DELETE_WATCH_LIST', { response });
    },
    async addAmazonProductToWatchList(store, { watchList, amazonProduct }) {
        let response = await watchListApi.addAmazonProduct(watchList, amazonProduct);
        loadEntity({ watchList: response.data });
    },
    async removeAmazonProductFromWatchList(store, { watchList, amazonProduct }) {
        let response = await watchListApi.removeAmazonProduct(watchList, amazonProduct);
        loadEntity({ watchList: response.data });
    },
};

const mutations = {
    LOAD_ENTITIES(state, { watchLists }) {
        if (watchLists)
            Object.values(watchLists).forEach(watchList => Vue.set(state.byId, watchList.id, watchList));
    },
    DELETE_WATCH_LIST(state, { response }) {
        Vue.delete(state.byId, response.id);
    },
};

export default {
    state,
    actions,
    mutations,
};
